<template>
  <div class="statisticalAnalysis">
    <el-row class="tableHearInputBox" type="flex" justify="space-between">
      <el-col>
        <el-select v-model="query.nf" @change="yearChange" filterable placeholder="请选择">
          <el-option
            v-for="item in yearList"
            :key="item.value"
            :label="item.label + '年'"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select v-model="query.kspc" filterable @change="tableLoad">
          <el-option label="全部批次" value=""></el-option>
          <el-option
            v-for="item in kspcList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="query.province"
          filterable
          placeholder="请选择"
          @change="provinceChange"
        >
          <el-option label="全部省份" value=""></el-option>
          <el-option
            v-for="item in nativeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select v-model="query.city" filterable placeholder="请选择" @change="cityChange">
          <el-option label="全部地市" value=""></el-option>
          <el-option
            v-for="item in cityList"
            :key="item.id"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="query.district"
          filterable
          placeholder="请选择"
          @change="districtChange"
        >
          <el-option label="全部区域" value=""></el-option>
          <el-option
            v-for="item in districtList"
            :key="item.id"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-button size="small" @click="exportExcel" type="primary">全表导出</el-button>
    </el-row>
    <el-table
      :row-style="getRowStyle"
      :data="tableList"
      tooltip-effect="dark"
      border
      ref="elTable"
      style="width: 100%"
      :header-cell-style="$store.getters.getTableHeadStyle"
      v-loading="tableIsLoad"
      element-loading-text="加载中"
      :height="$store.getters.getTableHeight"
    >
      <el-table-column prop="siteName" align="center" label="考点名称" min-width="110" />
      <el-table-column
        prop="provinceName"
        align="center"
        label="所属省份"
        min-width="140"
        show-overflow-tooltip
      />
      <el-table-column
        prop="cityName"
        align="center"
        label="所属地市"
        min-width="140"
        show-overflow-tooltip
      />
      <el-table-column
        prop="countiesName"
        align="center"
        label="所属区县"
        min-width="140"
        show-overflow-tooltip
      />
      <el-table-column prop="bmzrc" align="center" label="报名总人次" />
      <el-table-column prop="total" align="center" label="缴费总金额" />
      <el-table-column prop="xzrs" align="center" label="新的报名人次" min-width="110" />
      <el-table-column prop="lsrs" align="center" label="流失的考生人数" min-width="110">
        <template slot-scope="scope">
          <span :class="(scope.$index != 0 && scope.row.lsrs != 0) ? 'link' : ''" @click="getLsrs(scope)">{{
            scope.row.lsrs
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="bmzzl"
        align="center"
        label="与上年度相比的报名考生人数增长率"
        min-width="230"
      />
      <el-table-column
        prop="scorezzl"
        align="center"
        label="与上年度相比的缴费总金额增长率"
        min-width="220"
      />
    </el-table>
    <el-dialog
      title="流失的考生数"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
    >
      <el-table
        :data="tableData1"
        tooltip-effect="dark"
        border
        ref="elTable"
        style="width: 100%"
        height="550"
        :header-cell-style="$store.getters.getTableHeadStyle"
        v-loading="tableIsLoad1"
        element-loading-text="加载中"
      >
        <el-table-column
          key="name"
          prop="name"
          label="考生姓名"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          key="idNumber"
          prop="idNumber"
          label="身份证号"
          width="170"
          align="center"
        ></el-table-column>
        <el-table-column
          key="mobile"
          prop="mobile"
          label="联系电话"
          width="120"
          align="center"
        ></el-table-column>
        <el-table-column key="kspc" prop="kspc" label="最近报名批次" align="center">
          <template slot-scope="{ row }">
            {{ getTextPc(row.kspc).text }}
          </template>
        </el-table-column>
        <el-table-column
          key="registrationPointName"
          prop="registrationPointName"
          label="最近报名考点"
          align="center"
        ></el-table-column>
        <el-table-column
          key="subjectName"
          prop="subjectName"
          label="最近报考科目"
          align="center"
        ></el-table-column>
        <el-table-column
          key="testLevel"
          prop="testLevel"
          label="最近报考等级"
          align="center"
          column-key="testLevel"
        >
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="exportClick" :loading="exportTicketLoading"
          >导 出</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { exportFile } from '@/uitls/globalFun.js';
export default {
  data() {
    return {
      tableIsLoad: false,
      tableIsLoad1: false,
      tableList: [], //列表数据
      tableData1: [],
      proList: [], //省份下拉
      examSitList: [], //考点下拉
      tableHead: [], //表格头数据
      yearList: [], //年份集合
      kspcList: [
        { value: '1', label: '春季' },
        { value: '2', label: '夏季' },
        { value: '3', label: '秋季' },
        { value: '4', label: '冬季' },
      ],
      query: {
        province: '',
        district: '',
        city: '',
        nf: null,
        kspc: '',
      },
      dialogVisible: false,
      dialogQuery: {
        query: '',
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
      },
      nativeList: [],
      cityList: [],
      districtList: [],
      tableData: [],
      exportTicketLoading: false,
      siteId: '',
    };
  },
  async mounted() {
    //获取年份数据
    await this.getYearList();
    // await this.tableLoad();
    //获取下拉框数据
    this.getSelectList();
    this.getNtiveList();
  },
  methods: {
    async getYearList() {
      try {
        const [yearResponse] = await Promise.all([
          this.$axios.get('/examInformation/selectFilterData'),
        ]);
        // 解构获取当前年度的数据
        this.yearList = yearResponse.data.data;
        if (this.yearList && this.yearList.length > 0) {
          // this.query.nf = this.yearList[0].value;
          // this.kspcList = this.yearList[0].children
          let year = new Date().getFullYear();
          // console.log(year.Number());
          this.query.nf = year + '';
        }
        // 调用列表接口
        await this.tableLoad();

        // 执行接口调用成功后的逻辑
      } catch (error) {
        // 处理错误情况
      }
    },
    getTextPc(val) {
      let text = ['', '春季', '夏季', '秋季', '冬季'][val];
      return {
        text,
      };
    },
    provinceChange() {
      // 清空市和区的选择
      this.query.city = '';
      this.query.district = '';

      // 根据选择的省份获取城市列表
      const selectedProvince = this.nativeList.find((item) => item.value === this.query.province);
      this.cityList = selectedProvince ? selectedProvince.children : [];
      this.tableLoad();
    },
    cityChange() {
      // 清空区的选择
      this.query.district = '';

      // 根据选择的城市获取区列表
      const selectedCity = this.cityList.find((item) => item.value === this.query.city);
      console.log('this.districtList', this.districtList);
      this.districtList = selectedCity ? selectedCity.children : [];
      this.tableLoad();
    },
    districtChange() {
      this.tableLoad();
    },
    getNtiveList() {
      //省市区
      this.$axios.get('/assigns/tree/province').then((res) => {
        let arr = res.data.data;
        if (arr) {
          this.nativeList = arr.map((item) => {
            return {
              ...item,
              children: item.children.map((el) => {
                return {
                  ...el,
                  children: el.children.length
                    ? el.children.map((e) => {
                        delete e.children;
                        return {
                          ...e,
                        };
                      })
                    : '',
                };
              }),
            };
          });
        }
      });
    },
    // 获取行样式
    getRowStyle(row, rowIndex) {
      if (row.rowIndex === 0) {
        return {
          color: 'rgb(64, 158, 255)', // 蓝色
        };
      }
      return {}; // 默认样式
    },
    // 获取下拉框数据
    getSelectList() {
      this.$axios.get('/incomeAnalysis/newProvince').then((res) => {
        let data = res.data.data;
        this.proList = data;
      });
      this.$axios.get('/incomeAnalysis/examinationSite').then((res) => {
        let data = res.data.data;
        this.examSitList = data;
      });
    },
    //获取表格数据
    tableLoad() {
      //初始化数据
      this.tableHead = [];
      this.tableList = [];
      this.tableIsLoad = true;
      this.$axios.post('/dataAnalys/list', this.query).then((res) => {
        let data = res.data.data;
        this.tableList = data;
        this.tableIsLoad = false;
      });
    },
    getLsrs(scope) {
      if (scope.$index === 0 || scope.row.lsrs == 0) {
        return;
      }
      let row = scope.row;
      this.siteId = row.siteId;
      let query = { ...this.query, siteId: row.siteId };
      this.tableIsLoad1 = true;
      this.dialogVisible = true;
      this.$axios
        .post(`/dataAnalys/lsrs`, query)
        .then((res) => {
          let data = res.data.data;
          this.tableData1 = data;
          this.tableIsLoad1 = false;
        })
        .catch((err) => {
          this.tableIsLoad1 = false;
        });
    },
    handleClose () {
      this.siteId = '';
      this.dialogVisible = false;
      this.tableData = [];
      // this.dialogQuery = {
      //   query: '',
      //   pageNum: 1, // 当前页
      //   pageSize: 15, // 每页显示条数
      // };
      this.tableDisabled1 = false;
    },
    // async getList() {
    //   if (this.tableDisabled) return;
    //   this.dialogQuery.pageNum++;
    //   let page = Math.ceil(this.total / 15);
    //   if (this.dialogQuery.pageNum <= page) {
    //     let query = { ...this.query, type: this.type, ...this.dialogQuery };
    //     await this.$axios
    //       .post(`/dataAnalys/lsrs`, query)
    //       .then((res) => {
    //         let data = res.data.data.list;
    //         this.total = res.data.data.total;
    //         this.tableData = this.tableData.concat(data);
    //       })
    //       .catch((error) => {});
    //   }
    //   if (this.dialogQuery.pageNum > page) {
    //     this.tableDisabled = true;
    //   }
    // },
    exportClick() {
      this.exportTicketLoading = true;
      let query = { ...this.query, siteId: this.siteId};
      this.$axios
        .post('/dataAnalys/exportLsrs', query, { responseType: 'blob' })
        .then((res) => {
          this.$exportFile(res);
          this.exportTicketLoading = false;
          this.handleClose();
        })
        .catch((err) => {
          this.exportTicketLoading = false;
        });
    },
    //导出
    exportExcel() {
      this.$axios.post('/dataAnalys/export', this.query, { responseType: 'blob' }).then((res) => {
        exportFile(res);
      });
    },
    yearChange(val) {
      this.tableLoad();
    },
  },
};
</script>
<style lang="scss" scoped>
.statisticalAnalysis {
  .tableHearInputBox {
    .el-select {
      width: 140px;
      margin-right: 10px;
    }
  }
}
</style>
<style lang="scss">
.el-table__expand-icon {
  padding-top: 5px !important;
}
.el-table thead.is-group th {
  border: 1px solid #e4e4e4;
}
.link {
  text-decoration: underline;
  cursor: pointer;
}
</style>
